import React from 'react';

import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import st from './shared.module.sass';
import { TagPolicySubForm } from '../../../forms';

function StepTagPolicy() {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('handlers:добавлять тег к событию?')}
        </StepTitle>
      )}
    >
      <TagPolicySubForm />
    </Step>
  );
}

StepTagPolicy.fieldNames = [
  'tagPolicy',
];

export { StepTagPolicy };
